import styled from "styled-components";

export const AppLayout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const MainContent = styled.main`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`;
